// eslint-disable-next-line no-useless-escape
export const AGENTIO_PIXEL_ID = "the_farmer\'s_dog_pixel";
